// import { useProgress } from "@react-three/drei";
// import { usePlay } from "../contexts/Play";

// export const Overlay = () => {
//   const { progress } = useProgress();
//   const { play, end, setPlay, hasScroll } = usePlay();
//   return (
//     <div
//       className={`overlay ${play ? "overlay--disable" : ""}
//     ${hasScroll ? "overlay--scrolled" : ""}`}
//     >
//       <div
//         className={`loader ${progress === 100 ? "loader--disappear" : ""}`}
//       />
//       {progress === 100 && (
//         <div className={`intro ${play ? "intro--disappear" : ""}`}>
//           <h1 className="logo">
//             WAWATMOS
//             <div className="spinner">
//               <div className="spinner__image" />
//             </div>
//           </h1>
//           <p className="intro__scroll">Scroll to begin the journey</p>
//           <button
//             className="explore"
//             onClick={() => {
//               setPlay(true);
//             }}
//           >
//             Explore
//           </button>
//         </div>
//       )}
//       <div className={`outro ${end ? "outro--appear" : ""}`}>
//         <p className="outro__text">Wish you had a great flight with us...</p>
//       </div>
//     </div>
//   );
// };



// import { useEffect } from "react";
// import { useProgress } from "@react-three/drei";
// import { usePlay } from "../contexts/Play";

// export const Overlay = () => {
//   const { progress } = useProgress();
//   const { play, setPlay, hasScroll } = usePlay();

//   // When loading completes, start playing immediately
//   useEffect(() => {
//     if (progress === 100 && !play) {
//       setPlay(true);
//     }
//   }, [progress, play, setPlay]);

//   return (
//     <div
//       className={`overlay ${play ? "overlay--disable" : ""} ${hasScroll ? "overlay--scrolled" : ""}`}
//     >
//       <div className={`loader ${progress === 100 ? "loader--disappear" : ""}`} />

//       {/* No intro or explore button */}

//       {/* No outro */}

//     </div>
//   );
// };


import { useEffect } from "react";
import { useProgress } from "@react-three/drei";
import { usePlay } from "../contexts/Play";
// import { usePlay } from "../contexts/PlayContext";

const Overlay = () => {
  const { progress } = useProgress();
  const { play, setPlay, hasScroll } = usePlay();

  useEffect(() => {
    if (progress === 100 && !play) {
      setPlay(true);
    }
  }, [progress, play, setPlay]);

  return (
    <div
      className={`overlay ${play ? "overlay--disable" : ""} ${hasScroll ? "overlay--scrolled" : ""}`}
    >
      <div className={`loader ${progress === 100 ? "loader--disappear" : ""}`} />
    </div>
  );
};

export default Overlay;

